import "./FoodHeader.css";
import { MdRestaurantMenu, MdAdd, MdRefresh } from "react-icons/md";

function FoodHeader({
  onAddFood,
  onRefresh,
}) {
  return (
    <div className="food-header">

      <div className="food-header-left">

        <div className="food-header-icon">
          <MdRestaurantMenu />
        </div>

        <div>

          <h1>Food Management</h1>

          <p>
            Manage your menu, availability and pricing
          </p>

        </div>

      </div>

      <div className="food-header-right">

        <button
          className="food-refresh-btn"
          onClick={onRefresh}
        >
          <MdRefresh />
          Refresh
        </button>

        <button
          className="food-add-btn"
          onClick={onAddFood}
        >
          <MdAdd />
          Add Food
        </button>

      </div>

    </div>
  );
}

export default FoodHeader;